var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"module"},[_c('v-row',[_vm._l((_vm.tiles),function(tile){return [_c('tile',{key:tile,attrs:{"kpi":tile}})]})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }